module.exports = __webpack_public_path__ + "static/media/build-app-img.a8af34e3.png";